// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Checkbox_wrapper__3eDWp","input":"Checkbox_input__1M_Bh","box":"Checkbox_box__3OYJd","check":"Checkbox_check__efkOM","label":"Checkbox_label__1TULp"};